import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { FETCH_NEW_CAR_LIST } from '../../helpers/constants';
import { request } from '../../helpers/request';

export const fetchNewCarList = (dispatch: Dispatch) => {
    return request
        .getNewCarList()
        .then((response: AxiosResponse) => {
            dispatch({
                type: FETCH_NEW_CAR_LIST,
                payload: response.data ?? []
            });
        })

        .catch((err: AxiosError | Error) => {});
};
